import React from 'react';
import merge from 'lodash/merge';
import { ThemeProvider } from 'styled-components';
import { IntlProvider } from 'react-intl';
import config from '@nucleo/config';
import ClientIntlProvider from '@gravity/client-intl-provider';
import { Provider } from 'react-redux';
import * as NucleoManager from '@gravity/nucleo-manager';
import calendar from '@nucleo/calendar';
import filter from '@nucleo/filter';
import { getTranslationMessages } from './i18n';
import theme from './theme';
import renderTo from './renderer';
import WidgetContainer from './WidgetContainer';
import UsageTracker from "../src/UsageTracker";

const render = (root, props, language, translations = {}, curTheme = {}, actions, store) => {
  renderTo(
    <Provider store={store}>
      <IntlProvider locale={language} messages={translations}>
        <ThemeProvider theme={curTheme}>
          <WidgetContainer {...{ ...props, language, actions }} />
        </ThemeProvider>
      </IntlProvider>
    </Provider>,
    document.querySelector(root),
  );
};

const getNucleo = () => NucleoManager.getNucleo({ calendar }, { config, filter });
const getGlobalInit = (widgetDef) => ({
  config: async(params, store, nucleo) => {
    const { hostname, apiKey, language, restHost } = params;
    const { widgetBaseURL, widget, name } = widgetDef;
    const widgetName = widget || name;
    store.dispatch(nucleo.actions.config.init({ hostname, apiKey, language, restHost, widgetBaseURL, widgetName }));
    await store.dispatch(nucleo.actions.config.load());
    const cfg = nucleo.actions.config.getLocalState(store.getState());
    await ClientIntlProvider(cfg.language);
    return cfg;
  },
});

const AvailabilityCalendar = {
  getUsageTrackerConfig: () => UsageTracker.DEFAULT_USAGE_TRACKER_CONFIG,
  getNucleo,
  getGlobalInit,
  render: async (params, globalStore, nucleo = getNucleo()) => {
    const { hostname, apiKey, language, name, root, ...props } = params;
    let cfg = null;
    let store = null;
    if (globalStore) {
      store = globalStore;
      cfg = nucleo.actions.config.getLocalState(store.getState());
    } else {
      store = NucleoManager.createNucleoStore(nucleo);
      await getGlobalInit().config(store, nucleo, params);
      cfg = nucleo.actions.config.getLocalState(store.getState());
    }
    const translationMessages = await getTranslationMessages(cfg.language);
    const translations = merge(
      translationMessages,
      cfg.labelOverrides && cfg.labelOverrides.currentTranslations,
    );
    render(
      root,
      props,
      cfg.language,
      translations,
      theme((cfg.style && cfg.style.properties) || {}),
      nucleo.actions,
      store,
    );
  },
};

export default AvailabilityCalendar;
